/**
 * @file Identifies whether an entity investment is held in trust.
 */
import { ENTITY_MEMBERSHIP_INTEREST_TRUSTEE } from "@components/Domain";

import isEntityInvestment from "./isEntityInvestment";

type ProfileEntity = {
  membershipInterestsTitle?: string;
};

type Investment = {
  profileType?: string;
  profileEntity?: ProfileEntity;
};

/**
 * Identifies whether an entity investment lists a trustee as the membership interest title.
 */
const isTrustInvestment = (investment: Investment): boolean => {
  const isEntity = isEntityInvestment(investment);

  if (!isEntity) {
    return false;
  }

  const { profileEntity = {} } = investment;
  const { membershipInterestsTitle } = profileEntity;

  const isTrustee =
    membershipInterestsTitle === ENTITY_MEMBERSHIP_INTEREST_TRUSTEE;

  return isTrustee;
};

export default isTrustInvestment;
